/**
 * Copyright © 2026 Adnuntius AS.
 */
import {FileUploadComponent} from '../common/directives/file-upload/file-upload.component';
import {AssetRenderComponent} from '../common/directives/html/asset-render-component';
import {AssetTranscodeComponent} from '../common/directives/html/asset-transcode-component';
import {MimeTypeOutputComponent} from '../common/directives/mime-type-output-component';
import {PixelDimensionsOutputComponent} from '../common/directives/pixel-dimensions-output-component';
import {TranscodeConfigComponent} from '../common/directives/transcode-config-component';
import {GuardTypePipe} from '../common/filters/guard-type.pipe';
import {MimeTypeKeyPipe} from '../common/filters/mime-type-key.pipe';
import {AssetComponent} from './asset/asset.component';
import {AssetsComponent} from './asset/assets.component';
import {FileSizeOutputComponent} from './asset/file-size-output-component';
import {VideoAssetsComponent} from './asset/video-assets.component';

export const CREATIVE_ASSETS = [
  FileUploadComponent,
  AssetsComponent,
  AssetComponent,
  VideoAssetsComponent,
  AssetRenderComponent,
  AssetTranscodeComponent,
  TranscodeConfigComponent,
  FileSizeOutputComponent,
  PixelDimensionsOutputComponent,
  MimeTypeOutputComponent,
  GuardTypePipe,
  MimeTypeKeyPipe
];
